export const links = [
    {
        title: "Home",
        href: "/"
    },
    {
        title: "Selected Work",
        href: "/projects"
    },
  
    {
        title: "Meet Service",
        href: "/services"
    },
  
    {
        title: "Contacts",
        href: "/contact"
    },
    {
        title: "See About",
        href: "/aboutpage"
    }
]

export const footerLinks = [
    {
        title: "GitHub",
        href: "https://github.com/devshakilh"
    },
    {
        title: "LinkedIn",
        href: "https://www.linkedin.com/in/devshakilh/"
    },
    // {
    //     title: "Instagram",
    //     href: "https://instgram.com/devshakilh"
    // },
    // {
    //     title: "Twitter",
    //     href: "https://twitter.com/devshakilh"
    // }
]